<template>
  <v-card flat class="rounded-lg d-flex flex-column" outlined height="470px">
    <v-card-title>Tags</v-card-title>
    <v-card-text>
      <v-text-field
        v-model="search"
        label="Search"
        outlined
        dense
        hide-details
        clearable
        prepend-inner-icon="mdi-magnify"
        class="pa-0 ma-0">
      </v-text-field>

      <span class="h6 justify-center d-flex" v-if="!loading && totalItems === 0">
        There is no tags for this application.
      </span>
      <div class="scrollable-content" v-else>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :server-items-length="totalItems"
          :options.sync="tableOptions"
          :loading="loading"
          show-select
          class="elevation-0"
          item-key="name"
          selectable-key="name"
          single-select>
          <template v-slot:item.name="{ item }">
            <div class="d-flex justify-space-between align-center w-100">
              <span class="text-subtitle-1">{{ item.name }} ({{ item.size }}) </span>
              <v-tooltip bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" outlined>mdi-information-outline</v-icon>
                </template>
                <span>{{ item.path }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { apiService } from '../../service/api.service'

export default {
  name: 'Tags',
  props: {
    engineId: { type: Number, default: null },
    selectedTag: { type: Number, default: null }
  },
  data () {
    return {
      search: '',
      selected: [],
      headers: [{ text: 'Tag', value: 'name' }],
      items: [],
      totalItems: 0,
      loading: false,
      searchDebounceTimer: null,
      tableOptions: { page: 1, itemsPerPage: 10 }
    }
  },
  watch: {
    engineId (newVal) {
      this.tableOptions.page = 1
      this.selected = []
      if (newVal) {
        this.fetchPage()
      } else {
        this.items = []
        this.totalItems = 0
      }
    },
    search () {
      clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = setTimeout(() => {
        this.tableOptions.page = 1
        this.fetchPage()
      }, 300)
    },
    tableOptions: {
      handler () {
        if (this.engineId) {
          this.fetchPage()
        }
      },
      deep: true
    },
    selected (val) {
      const selectedItem = val.length > 0 ? val[0] : ''
      this.$emit('update:selected', selectedItem)
    }
  },
  mounted () {
    if (this.engineId) {
      this.fetchPage()
    } else {
      this.items = []
      this.selected = []
      this.totalItems = 0
    }
  },
  methods: {
    async fetchPage () {
      if (!this.engineId) return
      this.loading = true
      try {
        const { page, itemsPerPage } = this.tableOptions
        const res = await apiService.get(
          `admin/engine-llm-tag-configurations/by-engine/${this.engineId}`,
          { params: { page, per_page: itemsPerPage, search: this.search || '' } }
        )
        this.totalItems = res.data.total || 0
        this.items = (res.data.configurations || []).map(config => ({
          id: config.id,
          name: config.tag_name || `Tag ${config.tag_id}`,
          path: config.tag_name,
          size: config.tag_size ? config.tag_size + 'GB' : '',
          environment_variables: config.environment_variables || [],
          engine_arguments: config.engine_arguments || [],
          docker_options: config.docker_options || [],
          environmentContainerOptionsId: config.environment_container_options_id,
          engineArgumentsContainerOptionsId: config.engine_arguments_container_options_id,
          quantization: config.tag_quantization,
          parameters: config.tag_parameters,
          jetson_environment_variables: config.jetson_environment_variables || [],
          jetson_engine_arguments: config.jetson_engine_arguments || [],
          jetson_docker_options: config.jetson_docker_options || [],
          jetsonEnvironmentContainerOptionsId: config.jetson_environment_container_options_id,
          jetsonEngineArgumentsContainerOptionsId: config.jetson_engine_arguments_container_options_id
        }))
        if (this.selectedTag && this.selected.length === 0) {
          const match = this.items.find(t => t.id === this.selectedTag)
          if (match) this.selected = [match]
        }
      } catch (e) {
        console.error('Error fetching tag configurations:', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.scrollable-content {
  max-height: 380px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #FFFFFF
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

::v-deep .v-data-footer__select {
  display: none;
}
::v-deep .v-data-footer {
  display: flex;
  justify-content: end;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
::v-deep .v-data-table__wrapper table tbody tr td {
  padding: 0 !important;
  height: 36px;
  overflow-x: hidden;
  overflow-y: hidden;
}
::v-deep(.v-card__subtitle),
::v-deep(.v-card__text),
::v-deep(.v-card__title) {
  padding: 4px !important;
}
</style>
